<template>
  <div class="card-body">
    <h3 class="h5 mb-2">{{ trans('dashboard.account.profile.billing_address') }}</h3>

    <div class="alert alert-success" v-if="form.wasSuccessful">
      {{ trans('dashboard.alerts.success_update_billing_address') }}
    </div>

    <form role="form" @submit.prevent="submit">
      <div class="form_grid">
        <div class="form_group">
          <form-input
            id="user-billing_address"
            name="billing_address"
            type="text"
            v-model="form.billing_address"
            :label-text="trans('common.address')"
            :placeholder="trans('common.address')"
            :error="form.errors.billing_address"
          />
        </div>
        <div class="form_group">
          <form-input
            id="user-billing_address_line_2"
            name="billing_address_line_2"
            type="text"
            v-model="form.billing_address_line_2"
            :label-text="trans('common.address_line_2')"
            :placeholder="trans('common.address_line_2')"
            :error="form.errors.billing_address_line_2"
          />
        </div>
      </div>
      <div class="form_group pb-2">
        <form-input
          id="user-billing_city"
          name="billing_city"
          type="text"
          v-model="form.billing_city"
          :label-text="trans('common.city')"
          :placeholder="trans('common.city')"
          :error="form.errors.billing_city"
        />
      </div>
      <div class="form_grid">
        <div class="form_group">
          <form-input
            id="user-billing_state"
            name="billing_state"
            type="text"
            v-model="form.billing_state"
            :label-text="trans('common.state')"
            :placeholder="trans('common.state')"
            :error="form.errors.billing_state"
          />
        </div>
        <div class="form_group">
          <form-input
            id="user-billing_zip"
            name="billing_zip"
            type="text"
            v-model="form.billing_zip"
            :label-text="trans('common.postal_code')"
            :placeholder="trans('common.postal_code')"
            :error="form.errors.billing_zip"
          />
        </div>
      </div>
      <div class="form_group">
        <form-input
          id="user-billing_country"
          name="billing_country"
          type="select"
          v-model="form.billing_country"
          :options="countries"
          :allow-empty="false"
          track-by="code"
          label="name"
          :label-text="trans('common.country')"
          :error="form.errors.billing_country"
        />
      </div>
      <div class="form_row">
        <span></span>
        <form-button :value="trans('common.update')" :processing="form.processing"/>
      </div>
    </form>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/vue3";
import FormInput from "@/components/Shared/Form/Input/Index";
import FormButton from "@/components/Shared/Form/Button";

export default {
  name: "ProfileBillingAddressForm",

  components: {
    FormInput,
    FormButton
  },

  props: {
    user: Object,
    countries: Array
  },

  setup(props) {
    const form = useForm({
      'billing_address': props.user.billing_address,
      'billing_address_line_2': props.user.billing_address_line_2,
      'billing_city': props.user.billing_city,
      'billing_state': props.user.billing_state,
      'billing_zip': props.user.billing_zip,
      'billing_country': props.countries.find((country) => country.code === props.user.billing_country),
    })

    return {form}
  },

  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          billing_country: data.billing_country?.code
        }))
        .put(this.$route('dashboard.account.profile.billing_address.update'), {preserveScroll: true})
    }
  }
}
</script>
